import { workerApi } from '@/api';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { include, injectFilterParamHelper, whereOperators, } from '@/lib/query-parameter/filter';
import { embed, field, } from '@/lib/query-parameter/resource';
import { injectSortParamHelper } from '@/lib/query-parameter/sortby';
import PaginationOutput from '@/helpers/PaginationOutput';
import { timeZoneCode } from '@/constants/global';
import { changeStartEndStringTimeZone } from '@/utils/index';
import { workerProfitStoreType } from '@/constants/workerProfit/workerProfitStoreTypeOptionList';
import { workerProfitUseYnType } from '@/constants/workerProfit/workerProfitUseYnTypeOptionList';
import { workerProfitIsWithholdingTaxType } from '@/constants/workerProfit/workerProfitIsWithholdingTaxTypeOptionList';
import { workerMonthlyAttendanceUseYnType } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceUseYnTypeOptionList';
import WorkerVM from '@/view-model/worker-management/WorkerVM';
export default {
    // 모바일에서 사용
    async getWorkerListMobile({ hubIds, attendCode, pageNumber, pageSize, }) {
        const params = new QueryParameterBuilder()
            .addFilters(include('hubId', ...hubIds))
            .addFilters(include('attendCode', ...attendCode))
            .addFields(field('name', 'code', 'distributorId', 'hubId', 'statusCode', 'attendCode', 'nowAllocatedCount', 'nowPickupCount', 'finishCount', 'orderDelayTimeSecond', 'acceptedOrderViewLimitCount', 'maxAllocateCount'))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .build();
        const response = await workerApi.getWorkers(params);
        return response.data;
    },
    // 데스크탑에서 사용
    async getWorkerListOnly({ pageNumber, pageSize, hubId, filters = [], sortOption = [], }) {
        const params = new QueryParameterBuilder();
        if (hubId) {
            params
                .addFilters(include('hubId', hubId));
        }
        params
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addEmbeds(embed('hub', 'worker_insurance_deposit'));
        injectFilterParamHelper(params, filters);
        injectSortParamHelper(params, sortOption);
        const response = await workerApi.getWorkers(params.build());
        return PaginationOutput.adaptorFactory(response, WorkerVM);
    },
    // 라이더 수수료 그룹에 속한 workerList
    async getFeeGroupWorkerList({ hubId, groupId }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .addFilters(include('hubId', hubId))
            .addFilters(include('useYn', 'OK', 'STOP'))
            .addEmbeds(embed('WORKER_DELIVERY_FEE_GROUP'));
        injectFilterParamHelper(params, [
            {
                condition: whereOperators.equals,
                field: 'workerDeliveryFeeGroupId',
                value: groupId,
            },
        ]);
        const response = await workerApi.getWorkers(params.build());
        return response.data;
    },
    // 라이더 수수료 그룹에 등록 가능한 workerList (FeeGroup에 속한 라이더를 제외한 허브의 라이더)
    async getFeeGroupAvailableWorkerList({ hubId, groupId }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .addFilters(include('hubId', hubId))
            .addFilters(include('useYn', 'OK', 'STOP'))
            .addEmbeds(embed('WORKER_DELIVERY_FEE_GROUP'));
        injectFilterParamHelper(params, [
            {
                condition: whereOperators.notEquals,
                field: 'workerDeliveryFeeGroupId',
                value: groupId,
            },
        ]);
        const response = await workerApi.getWorkers(params.build());
        return response.data;
    },
    // TODO embed 관련 설명은 현재 API에 존재하지 않음, 웅석님 답변 슬랙 링크로 확인 가능 https://barogo.slack.com/archives/C01A1R67RFA/p1680764140663899?thread_ts=1680763782.518949&cid=C01A1R67RFA
    // 라이더 자동 캐시 차감 그룹에 속한 workerList
    async getWorkerCashAutoDeductGroupWorkerList({ groupId, hubId }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .addFilters(include('hubId', hubId))
            .addFilters(include('useYn', 'OK', 'STOP'))
            .addEmbeds(embed('WORKER_CASH_AUTO_DEDUCT_GROUP'));
        injectFilterParamHelper(params, [
            {
                condition: whereOperators.equals,
                field: 'workerCashAutoDeductGroupId',
                value: groupId,
            },
        ]);
        const response = await workerApi.getWorkers(params.build());
        return response.data;
    },
    // 라이더 자동 캐시 차감 그룹에 등록 가능한 workerList
    async getWorkerCashAutoDeductGroupAvailableWorkerList({ groupId, hubId }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .addFilters(include('hubId', hubId))
            .addFilters(include('useYn', 'OK', 'STOP'))
            .addEmbeds(embed('WORKER_CASH_AUTO_DEDUCT_GROUP'));
        injectFilterParamHelper(params, [
            {
                condition: whereOperators.notEquals,
                field: 'workerCashAutoDeductGroupId',
                value: groupId,
            },
        ]);
        const response = await workerApi.getWorkers(params.build());
        return response.data;
    },
    // 배차 취소 패널트 그룹에 속한 workerList
    async getWorkerAllocatedCancelPenaltyGroupWorkerList({ groupId, hubId }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .addFilters(include('hubId', hubId))
            .addFilters(include('useYn', 'OK', 'STOP'))
            .addEmbeds(embed('WORKER_PENALTY_GROUP'));
        injectFilterParamHelper(params, [
            {
                condition: whereOperators.equals,
                field: 'workerPenaltyGroupId',
                value: groupId,
            },
        ]);
        const response = await workerApi.getWorkers(params.build());
        return response.data;
    },
    // 배차 취소 패널트 그룹에 등록 가능한 workerList
    async getWorkerAllocatedCancelPenaltyGroupAvailableWorkerList({ groupId, hubId }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .addFilters(include('hubId', hubId))
            .addFilters(include('useYn', 'OK', 'STOP'))
            .addEmbeds(embed('WORKER_PENALTY_GROUP'));
        injectFilterParamHelper(params, [
            {
                condition: whereOperators.notEquals,
                field: 'workerPenaltyGroupId',
                value: groupId,
            },
        ]);
        const response = await workerApi.getWorkers(params.build());
        return response.data;
    },
    async quickConfigureWorker({ hubId, codes, orderDelayTimeSecond, maxAllocateCount, acceptedOrderViewLimitCount, }) {
        const response = await workerApi.permitWorker({
            hubId,
            codes,
            orderDelayTimeSecond,
            maxAllocateCount,
            acceptedOrderViewLimitCount,
        });
        return response.data;
    },
    async isPhoneExist({ phone }) {
        const response = await workerApi.postPhoneExistence({
            phone,
        });
        return response.data;
    },
    async postWorker(data) {
        const formData = {
            ...data,
        };
        // 하이픈 제거
        // 현재는 service layer에 있지만 이게 api layer로 올라갈 수도 있겠습니다..
        if (data.socialNumber && data.socialNumber.indexOf('-') > 0) {
            formData.socialNumber = data.socialNumber.replaceAll(/-+/g, '');
        }
        if (formData.workTime) {
            formData.workTime = changeStartEndStringTimeZone(formData.workTime, timeZoneCode.UTC);
        }
        // 픽업예상시간의 필드가 부정값이라 보낼 때 반대값으로 호출해야 함.
        formData.isImpossibleToChangePickupExpectedAt = !formData.isImpossibleToChangePickupExpectedAt;
        const response = await workerApi.postWorker(formData);
        return response.data;
    },
    async isHubEmployeeNumberExist({ hubEmployeeNumber }) {
        const response = await workerApi.postHubEmployeeNumberExistence({
            hubEmployeeNumber,
        });
        return response.data;
    },
    async getWorker({ workerCode }) {
        const params = new QueryParameterBuilder()
            .addEmbeds(embed('distributor', 'hub', 'worker_delivery_fee_group', 'worker_cash_auto_deduct_group', 'worker_penalty_group', 'worker_insurance_deposit'))
            .build();
        const response = await workerApi.getWorker(workerCode, params);
        return response.data;
    },
    async putWorkerDetail(data) {
        const { code, newData } = data;
        const formData = {
            ...newData,
        };
        if (formData.workTime) {
            formData.workTime = changeStartEndStringTimeZone(formData.workTime, timeZoneCode.UTC);
        }
        // 픽업예상시간의 필드가 부정값이라 보낼 때 반대값으로 호출해야 함.
        formData.isImpossibleToChangePickupExpectedAt = !formData.isImpossibleToChangePickupExpectedAt;
        const response = await workerApi.putWorkerDetail(code, formData);
        return response.data;
    },
    async editWorkerBasic({ workerCode, name, telNumber, workerRegDate, depositBaromoney, memo, }) {
        const data = {
            name,
            telNumber,
            workerRegDate,
            depositBaromoney,
            memo,
        };
        const response = await workerApi.putWorkersBasic(workerCode, data);
        return response.data;
    },
    async editWorkerWork({ workerCode, workTime, statusCode, employeeType, salaryType, cardDeviceType, }) {
        const data = {
            workTime,
            statusCode,
            employeeType,
            salaryType,
            cardDeviceType,
        };
        const response = await workerApi.putWorkersWork(workerCode, data);
        return response.data;
    },
    async editWorkerPrivacy({ workerCode, socialNumber, carNumber, licenseNumber, }) {
        const data = {
            socialNumber,
            carNumber,
            licenseNumber,
        };
        const response = await workerApi.putWorkersPrivacy(workerCode, data);
        return response.data;
    },
    async editWorkerPermission({ workerCode, isForceGpsOn, orderDelayTimeSecond, acceptedOrderViewLimitCount, isSharedOrderHidden, maxAllocateCount, minFinishMinuteAfterAllocated, isPossibleAllocateCancel, isPossiblePickupExpectedAtChange, isPossibleDropAddressChange, isPossiblePayMethodChange, workerDeliveryFeeGroup, }) {
        const data = {
            isForceGpsOn,
            orderDelayTimeSecond,
            acceptedOrderViewLimitCount,
            isSharedOrderHidden,
            maxAllocateCount,
            minFinishMinuteAfterAllocated,
            isPossibleAllocateCancel,
            isPossiblePickupExpectedAtChange,
            isPossibleDropAddressChange,
            isPossiblePayMethodChange,
            workerDeliveryFeeGroup,
        };
        const response = await workerApi.putWorkersPermission(workerCode, data);
        return response.data;
    },
    async putWorkers(data) {
        const { code, newData } = data;
        const response = await workerApi.putWorkers(code, newData);
        return response.data;
    },
    /**
     * 라이더 월별 출근표
     */
    async getWorkerMonthlyAttendance(payload) {
        const { pageSize, pageNumber, hubId, workerUseYn, yearMonth, fromTimePeriod, toTimePeriod, searchType, searchKey, } = payload;
        const params = new QueryParameterBuilder()
            .addPageSize(pageSize)
            .addPageNumber(pageNumber)
            .add('yearMonth', yearMonth)
            .add('fromTimePeriod', fromTimePeriod)
            .add('toTimePeriod', toTimePeriod);
        // 허브를 선택 한 경우 추가
        if (hubId) {
            params
                .add('hubId', hubId);
        }
        // 라이더 상태를 선택 한 경우 추가
        if (workerUseYn !== workerMonthlyAttendanceUseYnType.ALL) {
            params
                .add('workerUseYn', workerUseYn);
        }
        // 검색값이 있는 경우 추가
        if (searchKey) {
            params
                .add('searchType', searchType)
                .add('searchKey', searchKey);
        }
        const response = await workerApi.getWorkerMonthlyAttendance(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 라이더 수익 정보 조회 - (RestDoc: worker 수익 정보 조회)
     */
    async getWorkerProfitStatistic(payload) {
        const { pageSize, pageNumber, hubId, storeType, isWithholdingTax, useYn, searchType, searchKey, searchDateType, fromDate, toDate, sortOption, } = payload;
        const params = new QueryParameterBuilder()
            .addPageSize(pageSize)
            .addPageNumber(pageNumber)
            .add('searchDateType', searchDateType)
            .add('fromDate', fromDate)
            .add('toDate', toDate);
        // 허브를 선택 한 경우 추가
        if (hubId) {
            params
                .add('hubId', hubId);
        }
        // 원천세 여부를 선택 한 경우 추가
        if (isWithholdingTax !== workerProfitIsWithholdingTaxType.ALL) {
            const isWithholdingTaxValue = isWithholdingTax === workerProfitIsWithholdingTaxType.Y;
            params
                .add('isWithholdingTax', isWithholdingTaxValue);
        }
        // 가맹점 종류를 선택 한 경우 추가
        if (storeType !== workerProfitStoreType.ALL) {
            params
                .add('storeType', storeType);
        }
        // 라이더 상태를 선택 한 경우 추가
        if (useYn !== workerProfitUseYnType.ALL) {
            params
                .add('useYn', useYn);
        }
        // 검색값이 있는 경우 추가
        if (searchKey) {
            params
                .add('searchType', searchType)
                .add('searchKey', searchKey);
        }
        if (sortOption[0].field) {
            injectSortParamHelper(params, sortOption);
        }
        const response = await workerApi.getWorkerProfitStatistic(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
};
